<template>
  <div id="AboutMeImage5">
    <img
      style="width: 90%; translate: 0% 0%;"
      src="/static/about-me/i34.webp"
    />
    <StickMe name="3" size="35" left="11" top="-6" uk-parallax="x: -30%" />
    <StickMe name="12" size="17" left="6" top="15" />
    <StickMe name="99" size="14" left="11" top="78" />
    <StickMe name="95" size="20" left="1" top="71" />
    <StickMe
      name="97"
      size="21"
      left="97"
      top="58"
      uk-parallax="x: 10%"
      style="z-index: -1;"
    />
    <StickMe name="17" size="12" left="95" top="77" uk-parallax="x: -10%" />
    <StickMe name="96" size="18" left="84" top="76" />
    <StickMe
      name="98"
      size="33"
      left="105"
      top="85"
      uk-parallax="x: 50%,-440%"
    />
    <StickMe name="12" size="17" left="91" top="-5" />
  </div>
</template>

<script>
import StickMe from './StickMe.vue'

export default {
  components: {
    StickMe,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/about-me/AboutMeImage5.vue